import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.AccountUsageTwoStep.StepForm', {
    howOftenDoYouExpectTransactions: 'Roughly how often do you expect to send or receive transactions?',
    oneOff: 'One-off or infrequently',
    rangePerMonth: '{range} per month',
    totalMonthlySpend: 'What is your estimated total monthly spend?',
});
